<template>
    <input :class="['p-inputtext p-component', {'p-filled': filled}]" :value="modelValue" @keydown="onKeyDown" @focus="onFocus" @input="onInput" />
</template>

<script>
export default {
    name: 'InputText',
    emits: ['update:modelValue'],
    props: {
        modelValue: null
    },
    methods: {
        onKeyDown(event){
            this.$ArrowNavigate.arrownavigate(event);
        },
        onFocus(event){
            event.target.select();
        },
        onInput(event) {
            this.$emit('update:modelValue', event.target.value);
        }
    },
    computed: {
        filled() {
            return (this.modelValue != null && this.modelValue.toString().length > 0)
        }
    }
}
</script>
